import {Element} from '@chaysehartsuff/active-html';
import {Entity} from '@chaysehartsuff/active-html';
import {Button} from '@chaysehartsuff/active-html';
import {Color} from '@chaysehartsuff/active-html';
import {ActionOverlay} from '@chaysehartsuff/active-html';
import {FooterActions} from '@chaysehartsuff/active-html';
import {TextArea} from '@chaysehartsuff/active-html';

import {PencilIcon} from '@chaysehartsuff/active-html';
import {TrashIcon} from '@chaysehartsuff/active-html';

export default class BlogItemEntity extends Entity {
    /**
     * Action overlay for the blog item.
     * @type {ActionOverlay}
     */
    actionOverlay;

    /**
     * Footer actions for the blog item.
     * @type {FooterActions}
     */
    footerActions;

    /**
     * The element for containing the entire editor
     * @type {Element} editorContainer
     */
    editorContainer;

    /**
     * The element for displaying the blog item's preview.
     * @type {Element} previewContainer
     */
    previewContainer;

    /**
     * The active editor element.
     * @type {any} editorElement
     */
    editorElement;

    /**
     * The edit state of the blog item.
     * @type {boolean}
     */
    isEditing = false;

    /* ---- EVENTS ----- */
    static get onDeleteEvent() { return 'onDelete'; }
    static get onChangeEvent() { return 'onChange'; }

    constructor(text = 'Example text'){
        super();
        this.text = '<span class="ql-font-raleway">' + text + '</span>';
        // elements
        this.actionOverlay = new ActionOverlay(this.getActionButtons());
        this.editorContainer = new Element().addClass('hidden');
        this.previewContainer = new Element().addContent(this.text).addClass('p-2');
        this.footerActions = new FooterActions(this.getFooterButtons()).hide();

        this.addContent(this.actionOverlay);
        this.addContent(this.previewContainer);
        this.addContent(this.editorContainer);
        this.addContent(this.footerActions);

        this.addClass('my-5');
    }

    /**
     * Returns array of action buttons for the blog item.
     * @return {Button[]}
     */
    getActionButtons() {
        return [
            new Button('', Color.WHITE)
                .addContent(new PencilIcon().addClass('h-5 w-5 text-gray-700'))
                .onEvent('onclick', (e) => {
                    this.enableEdit();
                    this.onEdit(e);
                }),
            new Button('', Color.WHITE)
                .onEvent('onclick', (e) => {
                    this.event(BlogItemEntity.onDeleteEvent, this.getId());
                })
                .addContent(new TrashIcon().addClass('h-5 w-5 text-red-600'))
        ];
    }

    getFooterButtons() {
        return [
            new Button('Save', Color.BLUE).onEvent('onclick', (e) => {
                this.onSave(e);
                this.disableEdit();
            }),
            new Button('Cancel', Color.GRAY).onEvent('onclick', (e) => {
                this.disableEdit();
            })
        ];
    }

    /** ----- ACTIONS ----- */
    /**
     * Creates the main editor component and binds to this.editorElement
     * @returns {Element}
     */
    onEdit(e){
        this.editorElement = new TextArea(this.text);
        this.editorContainer.addContent(this.editorElement);
    }
    onSave(e) {
        this.text = this.editorElement.getValue();
        this.event(BlogItemEntity.onChangeEvent);
    }
    enableEdit() {
        this.isEditing = true;
        // Add classes for active editing state
        this.addClass('border-2');
        this.addClass('border-blue-500');
        this.addClass('shadow-lg');
        this.addClass('rounded-lg');

        // Init editor
        this.editorContainer.clearContent();
        this.editorContainer.removeClass('hidden');

        // Hide preview
        this.previewContainer.addClass('hidden');

        // Show footer actions
        this.footerActions.reveal();
        this.actionOverlay.hide();
    }
    disableEdit(){
        this.isEditing = false;
        this.removeClass('border-2');
        this.removeClass('border-blue-500');
        this.removeClass('shadow-lg');
        this.removeClass('rounded-lg');

        // Hide editor
        this.editorContainer.addClass('hidden');

        // Show preview
        this.previewContainer.setContent(this.compilePreview());
        this.previewContainer.removeClass('hidden');


        this.footerActions.hide();
        this.actionOverlay.reveal();
    }
    exportObject() {
        return {
            ...super.exportObject(),
            text: this.text
        }
    }

    /**
     * Gets the final stripped output for preview
     * @return {string}
     */
    compilePreview(){
        return this.text;
    }
}